<template>
  <b-card>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex flex-column align-items-start">
        <h5 class="card-title mb-0">{{ item.label }}</h5>
        <p class="text m-0" v-if="item.applied">Change Accepted</p>
        <p class="text m-0" v-if="item.ignored">Change Declined</p>
      </div>
      <b-button size="sm" variant="outline-primary" @click="item.opened = !item.opened" v-if="item.applied || item.ignored">
        <font-awesome-icon v-if="!item.opened" :icon="['fas', 'chevron-down']" />
        <font-awesome-icon v-else :icon="['fas', 'chevron-up']" />
      </b-button>
    </div>
    <b-collapse v-model="item.opened">
      <div class="pt-3">
        <div class="text-block">
          <div class="d-flex align-items-center justify-content-between mb-2" v-if="item.corrected_value">
            <div class="text">Display Removed Text</div>
            <form-switch
              v-model="showRemovals"
            />
          </div>
          <p class="text" v-html="renderDiff(item.original_value, item.corrected_value, showRemovals)" v-if="item.corrected_value"></p>
          <p class="text" v-else>{{ item.original_value }}</p>

          <template v-if="showFeedback">
            <h5 class="card-title mb-2 mt-2">AI Feedback</h5>
            <p>{{ item.feedback }}</p>
          </template>

          <template v-if="showAmenities && item.review_amenities && item.review_amenities.length > 0">
            <h5 class="card-title mb-2 mt-2">Review Amenities</h5>
            <ul>
              <li v-for="(amenity, amenityIndex) in item.review_amenities" :key="amenityIndex">
                <span class="text">{{ amenity.name }}</span>
                <form-switch
                  :disabled="item.applied || item.ignored"
                  class="ml-2"
                  v-model="amenity.checked"
                  @change="setAmenity(amenity.checked, amenity.id)"
                />
              </li>
            </ul>
          </template>
        </div>
        <div class="button-group mt-2" v-if="item.corrected_value && !item.applied">
          <b-button variant="primary" @click="updateValues(item.field, item.corrected_value)" v-if="!item.applied">
            Accept
          </b-button>
          <b-button variant="outline" @click="ignoreValue(item.field, item.original_value)" v-if="!item.applied && !item.ignored">
            Decline
          </b-button>
        </div>
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import FormSwitch from '../../../../generic/form-switch/form-switch.vue';

export default {
    components: {
        FormSwitch,
    },
    props: {
        item: Object,
        showFeedback: Boolean,
        showAmenities: Boolean,
        renderDiff: Function,
        updateValues: Function,
        ignoreValue: Function,
        setAmenity: Function,
    },
    data() {
        return {
            showRemovals: false,
        };
    },
};
</script>
